import { VraagMail } from './vraag-mail';

export class IndienenVragenMailRequest {
  polisnummer: string;
  contractnummer: string;
  sleutel: string;
  kenmerken: string[];
  kenmerken_titel: string;
  naam: string;
  email: string;
  vragen: VraagMail[];
}
